import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import { observer } from 'mobx-react';
import React from 'react';

import { Label } from 'core/components/label';
import { useStore } from 'core/store';
import { Card } from 'core/components/card';
import { currencyFormatter } from 'core/helpers/formatters';

import useStyles from './accounting-breakdown-styles';

function AccountingBreakdown() {
  const {
    account: {
      policies: { policy }
    }
  } = useStore();
  const classes = useStyles();
  return (
    <>
      <Label type="coverageValue">Accounting Breakdown</Label>
      <Card className={classes.container} alignItems="center" justify="space-between" container>
        <TableContainer>
          <Table className={classes.priceBreakdownTable}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Label className={classes.label}>Total Cash Collected</Label>
                  <Label className={classes.value}>{currencyFormatter(policy.currentTotalPaid)}</Label>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Label className={classes.label}>Pending Amount</Label>
                  <Label className={classes.value}>{currencyFormatter(policy.pendingAmount)}</Label>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
}

export default observer(AccountingBreakdown);
